"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkColumn = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../../../../components/SiteLinks/components/Group/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/no-array-index-key -- Array is not dynamic therefore we dont need this rule */

const LinkColumn = ({
  customSkeletons,
  children,
  ...rest
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.LINK_COLUMN),
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      role: "heading",
      component: "p",
      variant: "h6",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.LinkLabelSkeleton, {
        width: 85
      })
    }), customSkeletons ? customSkeletons.map(({
      skeletonWidth
    }, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ListLink, {
      role: "listitem",
      width: `${skeletonWidth}%`
    }, index)) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ListLink, {
        role: "listitem",
        width: "80%"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ListLink, {
        role: "listitem",
        width: "100%"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ListLink, {
        role: "listitem",
        width: "30%"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ListLink, {
        role: "listitem",
        width: "90%"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ListLink, {
        role: "listitem",
        width: "45%"
      })]
    }), children]
  });
};
exports.LinkColumn = LinkColumn;
